import React, { Component } from 'react';
import { NumberAsCurrency } from '../components/NumberAsCurrency.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    monthlySavings?: number;
    cashback?: number;
}

export class SwitcherSavingYes extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Yes! We can help you<br /><span className='doddltext'>save up to <NumberAsCurrency value={this.props.monthlySavings} /> a year</span><br />{(this.props.cashback ?? 0) !== 0 && <>Options also available with up to<br/><NumberAsCurrency value={this.props.cashback} /> cashback</>}</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <p>There are still some competitive long-term rates out there, let us make switching a doddl</p>
                    </div>
                    <div className='row'>
                        <h2><span className='doddltext'>Let’s see if we can secure this for you!</span></h2>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.props.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                    <LenderRow showDisclaimer />
                    </div>
                </div>
            </header>
        );
    }
}
